let homePopupData = {
  1: {
    iframeUrl: "https://www.youtube.com/embed/cZAbLGI6adQ",
    h2Title: "Antonia Ludden",
    pText:
      "I have taken a combined approach to menopause. Brain fog and memory loss really knocked my confidence. Neuaura has changed everything",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  2: {
    iframeUrl: "https://www.youtube.com/embed/YkXK9Jv_JTg?si=1NRlQJpBL3RM1A7a",
    h2Title: "Isabella Hammett",
    pText:
      "Perimenopause exhaustion FLOORED me and my brain fog was awful, using this alongside my HRT was the missing piece of the puzzle!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  3: {
    iframeUrl: "https://www.youtube.com/embed/003nadBXX7k?si=KeQvjjtcps9AW3DY",
    h2Title: "Emma Reade",
    pText:
      "If I had to take one thing to a desert island it would be this, my brain fog is now completely gone! My body needed this supplement and the benefits are nothing short of amazing!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
};
let customerStory = {
  1: {
    iframeUrl: "https://www.youtube.com/embed/g8YZo3jjgLw",
    h2Title: "Louise Able",
    pText:
      "As a menopause specialist I now couldn’t be without this. I recommend it to all of my clients too and the results are nothing short of amazing!!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  2: {
    iframeUrl: "https://www.youtube.com/embed/DgVBYRLgWiw",
    h2Title: "Emma Reade",
    pText:
      "If I had to take one thing to a desert island it would be this, my brain fog is now completely gone! My body needed this supplement and the benefits are nothing short of amazing!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  3: {
    iframeUrl: "https://www.youtube.com/embed/003nadBXX7k",
    h2Title: "Emma Reade (After)",
    pText:
      "I missed a couple of days of taking these and it was only then that I realised just how much of a positive impact they were having on me. I am completely obsessed and will never be without them now!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  4: {
    iframeUrl: "https://www.youtube.com/embed/42ZA3mZVcww",
    h2Title: "Dorte Jensen",
    pText:
      "After only 1 week I noticed my sleep drastically improve! I have also noticed a huge difference in my clarity and concentration which has been amazing as I am a teacher!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  5: {
    iframeUrl: "https://www.youtube.com/embed/OjPjDIAVOFs",
    h2Title: "Jo-Smyth Manning",
    pText:
      "I love them, they are the first thing I go to in the morning! They have made the biggest difference for me and I now can’t go without it. My husband even sees a difference in me!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  6: {
    iframeUrl: "https://www.youtube.com/embed/LQNSjcdoHnA",
    h2Title: "Kate Skrine",
    pText:
      "I honestly can truly say I feel so much more balanced and more like myself. I have more clarity, energy and I am absolutely thrilled with the results!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  7: {
    iframeUrl: "https://www.youtube.com/embed/cZAbLGI6adQ",
    h2Title: "Antonia Ludden",
    pText:
      "I was still struggling with my energy levels despite being on HRT and these have made me so energised, I have bet the mid-day crash and I am sleeping all night.",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  8: {
    iframeUrl: "https://www.youtube.com/embed/YkXK9Jv_JTg",
    h2Title: "Isabella Hammett",
    pText:
      "Perimenopause exhaustion FLOORED me and my brain fog was awful, using this alongside my HRT was the missing piece of the puzzle!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
  9: {
    iframeUrl: "https://www.youtube.com/embed/X5Hjrh1tDbk",
    h2Title: "Caroline Lown",
    pText:
      "My brain fog has completely gone and I have never felt better. I have tried so many things on the market and this has been the only thing that has worked. Can’t recommend enough!",
    watchUrl: "https://www.neuaura.co/products/daily-menopause-supplement",
  },
};
/* Start Popup Trigger  */
function popupView(type, id) {
  event.preventDefault();
  let data = homePopupData[id];
  if (type == "cusStory") {
    data = customerStory[id];
  }
  const modalHtml = `
      <div id="reviewPopupModal" class="popup">
        <div class="popup-content">
          <span class="close" onclick="closePopup()">&times;</span>
          <iframe src="${data.iframeUrl}" frameborder="0" allowfullscreen></iframe>
          <h2>${data.h2Title}</h2>
          <p>${data.pText}</p>
          <a class="roundBtnA" href="${data.watchUrl}" target="_blank">Shop now</a>
        </div>
      </div>
    `;
  document.body.insertAdjacentHTML("beforeend", modalHtml);
  document.getElementById("reviewPopupModal").style.display = "block";
}
function popupVideoOnly(type, id, url) {
  event.preventDefault();
  const modalHtml = `
      <div id="reviewPopupModal" class="popup">
        <div class="popup-content">
          <span class="close" onclick="closePopup()">&times;</span>
          <iframe src="${url}" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    `;
  document.body.insertAdjacentHTML("beforeend", modalHtml);
  document.getElementById("reviewPopupModal").style.display = "block";
}
function closePopup() {
  const modal = document.getElementById("reviewPopupModal");
  if (modal) {
    modal.parentNode.removeChild(modal);
  }
}

window.onclick = function (event) {
  const modal = document.getElementById("reviewPopupModal");
  if (event.target == modal) {
    closePopup();
  }
};
/* End Popup Trigger  */
/* Start Reviews Carousel  */
let reviews = [
  {
    text: "I couldn't even look at myself in the mirror, menopause turned me into a beach whale.. I had rolls in places I didn't even know was possible. I am 4 months in now with taking BloatBurn and I have lost 17lbs!",
    user: "B Thomson",
  },
  {
    text: "The daily menopause supplement has changed everything for me, it completely eased my symptoms. I then started the Bloatburn to shift some of the menobelly that I have accrued over the past 5 years. I can tell you that it WORKS. I am down 3kg and I don’t feel lethargic after I eat anymore.",
    user: "Brenda Armstrong",
  },
  {
    text: "I started Bloatburn 3 weeks ago, and I since then have lost 2.5kg. I am blown away! Anyone who knows me knows that 2.5kg of weight loss is ALOT for me!! I have since added the Daily menopause supplement to help control my rampant night sweats and uncontrollable mood swings. The results from both has been life-changing! Thank you!",
    user: "Rebekah Foster",
  },
];

let currentSlide = 0;
let timer;

function initCarousel() {
  // Create slides and dots
  createSlides();
  createDots();

  // Start autoplay
  startAutoplay();
}

function createSlides() {
  let carouselContainer = document.getElementById("reviews-carousel");
  if (carouselContainer) {
    carouselContainer.innerHTML = "";
    reviews.forEach((review, index) => {
      let slide = document.createElement("div");
      slide.classList.add("review-slide");

      // Create <p> for review text
      let reviewText = document.createElement("p");
      reviewText.textContent = review.text;
      slide.appendChild(reviewText);

      // Create <p> for user
      let userPara = document.createElement("p");
      userPara.textContent = "-" + review.user; // Adjust format as needed
      slide.appendChild(userPara);

      carouselContainer.appendChild(slide);
    });
  }
}

function createDots() {
  let dotsContainer = document.getElementById("carousel-dots");
  if (dotsContainer) {
    dotsContainer.innerHTML = "";

    reviews.forEach((review, index) => {
      let dot = document.createElement("div");
      dot.classList.add("carousel-dot");
      if (index === 0) {
        dot.classList.add("active");
      }
      dot.addEventListener("click", () => {
        goToSlide(index);
      });
      dotsContainer.appendChild(dot);
    });
  }
}

function goToSlide(index) {
  if (index >= 0 && index < reviews.length) {
    currentSlide = index;
    updateCarousel();
    resetAutoplay();
  }
}

function updateCarousel() {
  let carouselContainer = document.getElementById("reviews-carousel");
  let dots = document.querySelectorAll(".carousel-dot");

  // Update slide display
  if (carouselContainer) {
    let position = -currentSlide * carouselContainer.offsetWidth;
    carouselContainer.style.transform = `translateX(${position}px)`;
  }

  // Update active dot
  dots.forEach((dot, index) => {
    if (index === currentSlide) {
      dot.classList.add("active");
    } else {
      dot.classList.remove("active");
    }
  });
}

function startAutoplay() {
  timer = setInterval(() => {
    currentSlide = (currentSlide + 1) % reviews.length;
    updateCarousel();
  }, 3000);
}

function resetAutoplay() {
  clearInterval(timer);
  startAutoplay();
}

// Initialize carousel
initCarousel();
/* End Reviews Carousel  */

//Toggale Faq Section START
var faq1 = {
  0: {
    btn: "How do I take BloatBurn Supplement?",
    content: `
           Take 2 capsules just before your heaviest meal of the day. This
            tends to be dinner for a lot of people. Consistency is key, so
            please ensure to make it part of your daily routine for optimal
            results.
       `,
  },
  1: {
    btn: "What does BloatBurn help with?",
    content: `
            BloatBurn helps reduce belly bloat, relieves abdominal discomfort,
            enhances digestion, curbs sugar cravings, and boosts metabolism,
            helping you burn calories more efficiently.
       `,
  },
  2: {
    btn: "When will I experience the benefits?",
    content: `
                        Supplements like BloatBurn work best with consistency and a holistic
            approach. While some women notice reduced bloating in just a few
            days, others may need a few weeks or months to fully experience the
            gut-balancing benefits. To get the most out of BloatBurn—such as
            easing bloating, curbing sugar cravings, and supporting hormonal
            balance—combine it with a healthy, balanced diet. Pairing BloatBurn
            with nutritious eating habits and regular activity will amplify your
            progress. For weight loss results, give it at least 2 months of
            consistent use.
       `,
  },
  3: {
    btn: "Who is BloatBurn for?",
    content: `
            BloatBurn is perfect for anyone dealing with belly bloat and
            digestive discomfort, or those seeking a natural solution to support
            healthy weight loss.
       `,
  },
  4: {
    btn: "What are the ingredients?",
    content: `
            Our BloatBurn supplement features 10 potent ingredients, each with a
            specific purpose. The digestive enzyme aids in breaking down common
            food triggers, while natural herbs work to reduce bloating and
            relieve abdominal discomfort. Additionally, a clinically proven
            natural ingredient helps boost metabolism, supporting overall
            digestive health and weight management: Chromium, Fennel Seed,
            Ginger, Dandelion, Peppermint, Bromelain, MCT Oil, Black Pepper,
            Turmeric, Greenselect Green Tea Phytosome®
       `,
  },
  5: {
    btn: " Can I take it if I am on HRT?",
    content: `
            You can take out BloatBurn Supplement alongside your HRT, however if
            you do have any concerns we recommend speaking to your GP.
       `,
  },
  6: {
    btn: "Does BloatBurn contain fillers?",
    content: `
             No, just 100% natural and clean goodness!
       `,
  },
  7: {
    btn: "Is BloatBurn gluten-free and vegan?",
    content: `
            Yes all of our products are gluten-free, vegan friendly,
            cruelty-free, filler free and GMO-free!
       `,
  },
  8: {
    btn: "Can I take BloatBurn with other mediation?",
    content: `
            If you have any concerns please consult with a healthcare
            professional before taking Neuaura supplements to ensure they are
            safe for you.
       `,
  },
  9: {
    btn: "Can I take this with other supplements?",
    content: `
            Yes you can!
       `,
  },
  10: {
    btn: "Do I need to take BloatBurn daily to see results?",
    content: `
            Absolutely! Consistency is key. For optimal results, it's important
            to take our supplements daily, as your body needs time to absorb the
            ingredients and allow them to work effectively.
       `,
  },
  11: {
    btn: "Is BloatBurn pregnancy safe?",
    content: `
            No, this supplement should not be used during pregnancy or
            breastfeeding.
       `,
  },
  12: {
    btn: "Does BloatBurn contain laxatives or caffeine?",
    content: `
            No!
       `,
  },
  13: {
    btn: "How do I store BloatBurn?",
    content: `
            Store in a cool dry place away from direct sunlight.
       `,
  },
};

var faq2 = {
  0: {
    btn: "How do I take Daily Menopause Supplement?",
    content: `
            Take 2 capsules daily with a full glass of water—morning is a great
            time, as it’s easier to remember and sets a positive tone for the
            day. Consistency is crucial, so incorporating it into your daily
            routine will ensure you get the best results!
      `,
  },
  1: {
    btn: " What does Daily Menopause help with?",
    content: `
         Powered by clinically proven ingredients, this supplement tackles
            the root cause of menopause symptoms by naturally rebalancing your
            hormones. You'll find relief from over 12 of the most stubborn
            menopause symptoms, helping you regain your energy and feel like the
            best version of yourself!
       `,
  },
  2: {
    btn: " Can I take this with HRT?",
    content: `
                    Menopause is a unique experience for everyone, and finding what
            works best for you is key. Some of our customers find that our
            supplement alone provides all the support they need and have an
            amazing experience with it! Others prefer a combined approach, using
            our Daily Menopause Supplement alongside HRT for extra relief,
            especially when HRT doesn't address all of their symptoms. If you
            have any concerns or questions, we always recommend checking in with
            your healthcare provider for personalised guidance.
       `,
  },
  3: {
    btn: "Do I need to be on HRT to take this?",
    content: `
            Absolutely not! You don't need to be on HRT to take our supplement.
            It's designed to provide all the support and relief you need on its
            own, helping you navigate this important phase naturally.
       `,
  },
  4: {
    btn: " Who is Daily Menopause for?",
    content: `
            Our Daily Menopause Supplement is suitable for women of all ages who
            are going through perimenopause, menopause or post menopause. Our
            supplement is formulated to be your solid companion throughout your
            full menopause journey.
       `,
  },
  5: {
    btn: "What are the ingredients?",
    content: `
             Each of these natural extracts and vitamins have been meticulously
            chosen and measured in amounts that are clinically validated to
            support your body and provide relief from over 12 of the most common
            menopause symptoms: Vitamin D3, Vitamin K2, Vitamin C, Vitamin B6,
            Vitamin B12, Biotin, Pantothenic Acid, Maca Root, Ashwagandha Root,
            Red Clover, Sage Leaf, Bacopa Monnieri Extraxt.
       `,
  },
  6: {
    btn: "How long will it take to feel results?",
    content: `
        It is important to remember that everyone’s timeline of results can
            vary. Some women notice a different within days, while others may
            need weeks or even months of consistent use to fully reset,
            rebalance and regain control of their mind, body and hormones.
       `,
  },
  7: {
    btn: "Does Daily Menopause contain fillers?",
    content: `
        Our products are 100% filler-free. They are simply a blend of
            powdered herbs, minerals, vitamins, and micronutrients encapsulated
            in a vegan shell. Nothing but clean, powerful goodness!
       `,
  },
  8: {
    btn: "Is Daily Menopause gluten-free and vegan?",
    content: `
            Yes, all Neuaura products are gluten-free, vegan and made from
            high-quality, non-GMO ingredients.
       `,
  },
  9: {
    btn: " Can I take this with other medication?",
    content: `
            If you are on other medication or have any concerns please consult
            with your healthcare professional as they know your medical history
            and will be able to provide personalised advice.
       `,
  },
  10: {
    btn: "How does Daily Menopause work?",
    content: `
            Our daily menopause supplement is designed to naturally restore
            hormonal balance using 12 carefully selected ingredients like
            Ashwagandha, Maca, and Sage. These work together to reduce hot
            flashes, night sweats, anxiety, and brain fog while improving
            energy, mood, and sleep. The formula also helps promote better
            cognitive function, alleviate stress, and boost overall well-being.
            Clinically validated ingredients ensure fast and long-lasting
            results, targeting the root causes of menopause symptoms for a
            holistic approach to relief.
       `,
  },
  11: {
    btn: "Do I need to take this daily to see results?",
    content: `
                    Yes, to see optimal results, it's essential to take the supplement
            daily. Consistency is key, as skipping doses can prevent your body
            from receiving the full benefit of the natural ingredients designed
            to support hormonal balance. Regular, daily use ensures the
            supplement works effectively to help alleviate menopause symptoms
            and promote overall well-being. For best results, make it part of
            your routine!
       `,
  },
  12: {
    btn: "What are the key symptoms this helps with?",
    content: `
            <ul>
              <li>Hot flashes and night sweats</li>
              <li>Mood swings, irritability, and anxiety</li>
              <li>Fatigue and low energy</li>
              <li>Brain fog and memory issues</li>
              <li>Sleep disturbances</li>
              <li>Hormonal Balance</li>
              <li>Libido</li>
            </ul>
    `,
  },
  13: {
    btn: "Does Daily Menopause contain caffeine?",
    content: `
        No, our Daily Menopause supplement does not contain caffeine. It's formulated with natural, non-stimulant ingredients to support hormonal balance and relieve menopause symptoms without causing jitteriness or sleep disturbances that can be associated with caffeine.
       `,
  },
  14: {
    btn: "How do I store Daily Menopause Supplement?",
    content: `
         To store the Daily Menopause supplement, keep the bottle in a cool, dry place away from direct sunlight and moisture. Ensure the lid is tightly closed after each use to maintain the freshness and effectiveness of the ingredients. It's best to store it at room temperature for optimal shelf life.
       `,
  },
};
var acheFreefaq = {
  0: {
    btn: "How do I take Ache-Free Supplement?",
    content: `Take 2 capsules daily with a full glass of water. Capsules should be taken with food or shortly after a meal. Consistency is crucial, so incorporating it into your daily routine will ensure you get the best results!`,
  },
  1: {
    btn: "What does Ache-Free help with?",
    content: `Ache-Free is specially designed to help relieve joint pain, stiffness, and inflammation commonly experienced during menopause. It also supports mobility, flexibility, and bone strength, allowing you to stay active and comfortable throughout this stage of life.`,
  },
  2: {
    btn: "Can I take this with other Neuaura supplements?",
    content: `Yes, Ache-Free can be taken alongside other Neuaura supplements. Each product is carefully formulated to complement one another and provide comprehensive support during menopause.`,
  },
  3: {
    btn: "Who is Ache-Free for?",
    content: `Ache-Free is formulated for women going through menopause who are experiencing joint pain, stiffness, or inflammation. It’s perfect for anyone looking to stay active, support joint health, and maintain mobility and strength during this stage of life.`,
  },
  4: {
    btn: "What are the ingredients?",
    content: `Ache-Free is made with powerful, natural ingredients known for their joint-supporting benefits: Glucosamine (D-Glucosamine HCL), MSM Powder, Turmeric, Boswellia Serrata, Reishi Mushroom, and Vitamin D3.`,
  },
  5: {
    btn: "How long will it take to feel results?",
    content: `Most women start noticing improvements within 2 to 4 weeks of consistent use, but for the best results, we recommend taking Ache-Free daily for at least 3 months. Everyone’s experience is different, so be patient and give your body time to benefit from the supplement.`,
  },
  6: {
    btn: "Does Ache-Free contain fillers?",
    content: `No, Ache-Free is free from fillers, artificial additives, and unnecessary ingredients. We focus on providing a clean, effective formula made with high-quality, natural ingredients to support your joint health during menopause.`,
  },
  7: {
    btn: "Is Ache-Free gluten-free and vegan?",
    content: `Yes, Ache-Free is both gluten-free and vegan. We’re committed to creating supplements that fit your dietary needs while delivering effective support for joint health during menopause.`,
  },
  8: {
    btn: "Can I take this with other medication?",
    content: `Ache-Free is made with natural ingredients, but we always recommend consulting with your healthcare provider before adding a new supplement to your routine or combining it with prescription medications. They know your medical history and can provide personalised advice to ensure there are no interactions and that it’s safe for you.`,
  },
  9: {
    btn: "Do I need to take this daily to see results?",
    content: `Yes, for the best results, we recommend taking Ache-Free daily. Consistency is key to experiencing the full benefits, as it helps support joint health, reduce inflammation, and improve mobility over time.`,
  },
  10: {
    btn: "What are the key symptoms this helps with?",
    content: `Ache-Free helps with joint pain, stiffness, inflammation, and reduced mobility, which are common symptoms many women experience during menopause. It also supports overall joint health and flexibility, helping you stay active and comfortable throughout the day.`,
  },
  11: {
    btn: "How do I store Ache-Free Supplement?",
    content: `Store Ache-Free in a cool, dry place, away from direct sunlight and humidity. Keep the bottle tightly closed to preserve the quality of the ingredients. For best results, make sure it's out of reach of children.`,
  },
  12: {
    btn: "Are there any side-effects?",
    content: `Ache-Free is made with natural ingredients and is generally well-tolerated. However, as with any supplement, some individuals may experience mild digestive discomfort, especially when first starting. We always recommend speaking to your healthcare provider before adding any new supplement to your routine. If you experience any side effects, stop taking it immediately and consult with your healthcare provider.`,
  },
};
var intimate = {
  0: {
    btn: "How do I take Intimate+?",
    content: `Take 2 capsules daily with water — ideally at the same time each day to keep things consistent. No creams, no fuss. Just a simple daily habit.`,
  },
  1: {
    btn: "How long will it take to feel results?",
    content: `Everyone’s body is different, but many women start to notice changes within 2–4 weeks. For best results, we recommend taking Intimate+ consistently for at least 3 months.`,
  },
  2: {
    btn: "Can I take this with other Neuaura supplements?",
    content: `Yes! Intimate+ is designed to work beautifully alongside all of our other supplements. Each supports different (but equally important) areas of menopausal health.`,
  },
  3: {
    btn: "What are the ingredients?",
    content: `Intimate+ contains Maca Root, Korean Ginseng, Damiana, L-Arginine, Zinc, Vitamin B6, Tribulus, Barrenwort, Fenugreek, and more — all carefully chosen to support spark, mood, and connection.`,
  },
  4: {
    btn: "Is Intimate+ vegan and gluten-free?",
    content: `Yes — Intimate+ is 100% vegan, gluten-free, and made without any artificial fillers or binders.`,
  },
  5: {
    btn: "Can I take this with medication?",
    content: `If you're taking any medication or have a health condition, we always recommend checking with your GP or healthcare provider before starting any new supplement.`,
  },
  6: {
    btn: "Who is Intimate+ for?",
    content: `Intimate+ is for menopausal and perimenopausal women who want to feel more connected, confident, and comfortable when it comes to connection — whether you’re in a relationship or simply reconnecting with yourself.`,
  },
  7: {
    btn: "Can I take Intimate+ if I’m on HRT?",
    content: `Yes — Intimate+ can be taken alongside HRT. However, as with any supplement, we recommend speaking with your healthcare provider to make sure it’s the right fit for your individual needs.`,
  },
  8: {
    btn: "Is Intimate+ pregnancy safe?",
    content: `Intimate+ is not recommended for use during pregnancy or breastfeeding. If you are pregnant, trying to conceive, or breastfeeding, please consult your doctor before taking any supplements.`,
  },
  9: {
    btn: "Does Intimate+ contain any fillers or bulkers?",
    content: `Nope! Intimate+ is free from unnecessary fillers, bulkers, and artificial additives. Just pure, purposeful ingredients chosen to support your libido, mood, and hormonal balance.`,
  },
  10: {
    btn: "How do I store Intimate+?",
    content: `Keep it in a cool, dry place away from direct sunlight. No need to refrigerate.`,
  },
  11: {
    btn: "Are there any side effects?",
    content: `Intimate+ is made with natural ingredients and is well tolerated by most. As with any supplement, we recommend reading the label and checking in with your healthcare provider if you have any concerns.`,
  },
};

function handleToggleClick(sectionId, toggleContent, element) {
  const isMobile = window.innerWidth <= 768;
  const contentParam = isMobile
    ? element.getAttribute("data-mobile")
    : element.getAttribute("data-desktop");

  showToggleContent(sectionId, toggleContent, contentParam);
}

function showToggleContent(sectionId, contentId, type) {
  const container = document.getElementById(sectionId);
  const toggleContent = container.querySelectorAll("div[id^=toggle]");
  toggleContent.forEach((content) => (content.style.display = "none"));
  console.log("WHY IM HERE 1 ", sectionId, contentId, type);
  if (type == "ingBloatburn") {
    document.getElementById(contentId).style.display = "flex";
    populateIngDescription(
      BloatBurnObj,
      "GreenselectPhytosome",
      "sec2IngDescription1"
    );
    manuallyAddactiveLi(contentId, 0);
  } else if (type == "ingMenapause") {
    document.getElementById(contentId).style.display = "flex";
    populateIngDescription(
      dailyMenopauseObj,
      "MacaRoot",
      "sec2IngDescription2"
    );
    manuallyAddactiveLi(contentId, 0);
  } else if (type == "ingBloatburnMobile") {
    document.getElementById(contentId).style.display = "flex";
    mobIngGenerate(BloatBurnObj, "BloatBurn", "toggle3Content");
  } else if (type == "ingMenapauseMobile") {
    document.getElementById(contentId).style.display = "flex";
    mobIngGenerate(dailyMenopauseObj, "dailyMenopaus", "toggle4Content");
  } else {
    document.getElementById(contentId).style.display = "block";
  }
  // Remove active class from buttons and add it to the current one
  const buttons =
    container.previousElementSibling.querySelectorAll(".toggle-button");
  buttons.forEach((btn) => btn.classList.remove("active"));
  event.target.classList.add("active");
}
function handleResponsiveContent() {
  const showDesktopElements = document.querySelectorAll(".showDesktop");
  const showMobileElements = document.querySelectorAll(".showMobile");

  if (window.innerWidth <= 768) {
    // Remove all '.showDesktop' elements if the screen is 768px or less
    showDesktopElements.forEach((element) => {
      element.remove();
    });
  } else {
    // Remove all '.showMobile' elements if the screen is larger than 768px
    showMobileElements.forEach((element) => {
      element.remove();
    });
  }
}
// Open FAQ Modal
function openFAQModal(faqKey) {
  // const faqData = window[faqKey];
  // const faqData = faqKey == "faq1" ? faq1 :faq2;
  var faqData;
  if (faqKey == "faq1") {
    faqData = faq1;
  } else if (faqKey == "faq2") {
    faqData = faq2;
  } else if (faqKey == "acheFreefaq") {
    faqData = acheFreefaq;
  } else if (faqKey == "intimate") {
    faqData = intimate;
  }

  const faqModalContent = document.getElementById("faqModalContent");
  faqModalContent.innerHTML = "";
  let html = "";
  for (let key in faqData) {
    const faq = faqData[key];
    html += `
            <div class="faq-item-wrapper" id="faqWrapper${key}">
              <button class="faq-collapse-button" onclick="toggleFAQCollapse('faqWrapper${key}')">
                ${faq.btn}
              </button>
              <div id="faqCollapse${key}" class="faq-collapse-description">
                ${faq.content}
              </div>
            </div>
          `;
    faqModalContent.innerHTML = html;
  }

  document.getElementById("faqModal").style.display = "block";
  document.getElementById("faqOverlay").style.display = "block";
}
function closeFAQModal() {
  document.getElementById("faqModal").style.display = "none";
  document.getElementById("faqOverlay").style.display = "none";
}
function toggleFAQCollapse(wrapperId) {
  // Get all FAQ wrappers
  const allWrappers = document.querySelectorAll(".faq-item-wrapper");

  // Loop through all wrappers and collapse them
  allWrappers.forEach((wrapper) => {
    if (wrapper.id !== wrapperId) {
      wrapper.classList.remove("collapseExpand");
    }
  });

  // Toggle the clicked FAQ wrapper
  const wrapper = document.getElementById(wrapperId);
  if (wrapper.classList.contains("collapseExpand")) {
    wrapper.classList.remove("collapseExpand");
  } else {
    wrapper.classList.add("collapseExpand");
  }
}

//  ingredients Js START

//  ingredients Js END

// Define objects for ingredients
function preloadImages(obj) {
  for (let ingredient in obj) {
    let img = new Image();
    img.src = obj[ingredient].imgUrl;
  }
}
// Example ingredient objects
var dailyMenopauseObj = {
  MacaRoot: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Maca_Root.png?v=1727160644",
    title: "Maca Root",
    ulItems: [
      "Energy",
      "Hot Flushes",
      "Libido",
      "Balances Hormones",
      "Mood Swings",
    ],
  },
  Ashwagandha: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Ashwagandha_8d3da7f8-de23-430b-98fa-765df86288b0.png?v=1727160645",
    title: "Ashwagandha",
    ulItems: [
      "Anxiety",
      "Irritability",
      "Sleep",
      "Balances Hormones",
      "Stress",
    ],
  },
  RedClover: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Red_Clover_4f777577-3573-48fe-a40e-14988458610a.png?v=1727160644",
    title: "Red Clover",
    ulItems: [
      "Mood",
      "Hot Flushes",
      "Night Sweats",
      "Bone Health",
      "Mental Clarity",
    ],
  },
  Reishi: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/reishi.png?v=1733465419",
    title: "Reishi",
    new: true,
    ulItems: [
      "Mood Swings",
      "Stress & Anxiety",
      "Sleep",
      "Regulates Hormones",
      "Fatigue",
    ],
  },
  VitaminB6: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Vitamin_B6.png?v=1727160644",
    title: "Vitamin B6",
    ulItems: [
      "Energy",
      "Mood Swings",
      "Sleep",
      "Balance Hormones",
      "Irritability",
    ],
  },
  SageLeaf: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Sage_Leaf.png?v=1727160644",
    title: "Sage Leaf",
    ulItems: [
      "Hot Flushes",
      "Mood Swings",
      "Memory",
      "Balance Hormones",
      "Concentration",
    ],
  },
  Bacopa: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Bacopa_2f22e394-f873-406c-921f-fcd1b2d127ba.png?v=1727160644",
    title: "Bacopa",
    ulItems: ["Memory", "Mood Swings", "Stress", "Anxiety", "Sleep"],
  },
  Ginseng: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/ginseng.png?v=1733465417",
    title: "Ginseng",
    new: true,
    ulItems: ["Energy", "Fatigue", "Concentration", "Mood Swings", "Memory"],
  },
};

var BloatBurnObj = {
  GreenselectPhytosome: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/bloatburn_ing2.png?v=1727150916",
    title: "Greenselect Phytosome®",
    ulItems: [
      "Blood Sugar",
      "Sugar Cravings",
      "Reduces Bloating",
      "Boosts Metabolism",
      "Fat Buring",
    ],
  },
  Bromelain: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/bloatburn_ing1.png?v=1727150917",
    title: "Bromelain",
    ulItems: [
      "Digestion",
      "Metabolism",
      "Reduces Bloating",
      "Anti-inflammatory",
      "Nutrient Absorption",
    ],
  },
  Ginger: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Ginger_da681b38-b57f-4f91-ba50-23badb7667f5.png?v=1727160644",
    title: "Ginger",
    ulItems: [
      "Nausea",
      "Digestion",
      "Metabolism",
      "Anti-inflammatory",
      "Blood Sugar Levels",
    ],
  },
  Chromium: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/chronium.png?v=1727160645",
    title: "Chromiums",
    ulItems: [
      "Metabolism",
      "Weight Loss",
      "Heart Health",
      "Blood Sugar Levels",
      "Sugar Cravings",
    ],
  },
  Turmeric: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Turmeric_798e8a3a-5589-4fa9-8be0-0e84574e93e9.png?v=1727160644",
    title: "Turmeric",
    ulItems: [
      "Digestion",
      "Weight Loss",
      "Metabolism",
      "Anti-inflammatory",
      "Blood Sugar",
    ],
  },
  Peppermint: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Peppermint_56f2cd7e-3f3a-4ab6-8a7f-8f8905644b93.png?v=1727160644",
    title: "Peppermint",
    ulItems: ["Digestion", "Weight Loss", "Metabolism", "Anti-inflammatory", "Blood Sugar"],
  },
};
var acheFreeObj = {
  Reishi: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Reishi1.png?v=1735828775",
    title: "Reishi",
    description:
      "A powerful adaptogen used in traditional medicine to reduce inflammation and relieve joint discomfort.",
    ulItems: [
      "Inflammation",
      "Mobility",
      "Recovery",
      "Immune Function",
      "Hormonal Balance",
    ],
  },
  Boswellia: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Boswellia.png?v=1735828775",
    title: "Boswellia",
    description:
      "A traditional herb thats been known for its potent anti-inflammatory properties.",
    ulItems: [
      "Inflammation",
      "Mobility",
      "Stress",
      "Joint Discomfort",
      "Joint Health",
    ],
  },
  Turmeric: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Turmeric_4a972bfd-40da-47b6-97e8-bcb2f589b713.png?v=1735828775",
    title: "Turmeric",
    description:
      "A natural spice known for its potential anti-inflammatory properties, which can help with joint discomfort.",
    ulItems: ["Anti-inflammatory", "Mobility", "Joint Comfort"],
  },
  VitaminD3: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/VitaminD3.png?v=1735828775",
    title: "Vitamin D3",
    description:
      "Vitamin D3 is a vital nutrient, also known as the “sunshine vitamin,” which plays a crucial role in bone health and immune function.",
    ulItems: ["Bone Health", "Anti-inflammatory", "Muscle Function"],
  },
  Glucosamine: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Glucosamine.png?v=1735828774",
    title: "Glucosamine",
    description:
      "Glucosamine is a naturally occurring compound found in the body, primarily in cartilage, where it helps maintain its structure and function.",
    ulItems: ["Cartilage Health", "Flexibility", "Joint Repair"],
  },
  MSM: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/VitaminD3.png?v=1735828775",
    title: "MSM",
    description:
      "It helps break down toxins and free radicals that can damage joint tissues, promoting recovery and easing joint discomfort.",
    ulItems: [
      "Inflammation",
      "Flexibility",
      "Recovery",
      "Antioxidant Properties",
      "Memory",
    ],
  },
};
var intimateObj = {
  Reishi: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Reishi1.png?v=1735828775",
    title: "Reishi",
    description:
      "A powerful adaptogen used in traditional medicine to reduce inflammation and relieve joint discomfort.",
    ulItems: [
      "Inflammation",
      "Mobility",
      "Recovery",
      "Immune Function",
      "Hormonal Balance",
    ],
  },
  Boswellia: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Boswellia.png?v=1735828775",
    title: "Boswellia",
    description:
      "A traditional herb thats been known for its potent anti-inflammatory properties.",
    ulItems: [
      "Inflammation",
      "Mobility",
      "Stress",
      "Joint Discomfort",
      "Joint Health",
    ],
  },
  Turmeric: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Turmeric_4a972bfd-40da-47b6-97e8-bcb2f589b713.png?v=1735828775",
    title: "Turmeric",
    description:
      "A natural spice known for its potential anti-inflammatory properties, which can help with joint discomfort.",
    ulItems: ["Anti-inflammatory", "Mobility", "Joint Comfort"],
  },
  VitaminD3: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/VitaminD3.png?v=1735828775",
    title: "Vitamin D3",
    description:
      "Vitamin D3 is a vital nutrient, also known as the “sunshine vitamin,” which plays a crucial role in bone health and immune function.",
    ulItems: ["Bone Health", "Anti-inflammatory", "Muscle Function"],
  },
  Glucosamine: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/Glucosamine.png?v=1735828774",
    title: "Glucosamine",
    description:
      "Glucosamine is a naturally occurring compound found in the body, primarily in cartilage, where it helps maintain its structure and function.",
    ulItems: ["Cartilage Health", "Flexibility", "Joint Repair"],
  },
  MSM: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/VitaminD3.png?v=1735828775",
    title: "MSM",
    description:
      "It helps break down toxins and free radicals that can damage joint tissues, promoting recovery and easing joint discomfort.",
    ulItems: [
      "Inflammation",
      "Flexibility",
      "Recovery",
      "Antioxidant Properties",
      "Memory",
    ],
  },
    VitaminC: {
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0563/2209/7231/files/vitaminC.webp?v=1746850019",
    title: "Vitamin C",
    description:
      "Vitamin C supports joint health by neutralising free radicals that cause inflammation and damage to joint tissues.",
    ulItems: [
      "Circulation",
      "Pain Relief",
      "Collagen",
      "Antioxidant Protection",
      "Immune Support",
    ],
  },
};
// Function to populate the ingredient description

function populateIngDescription(obj, ingredient, ingDescriptionId, element) {
  let ingData = obj[ingredient];

  if (!ingData) {
    console.error("No data found for ingredient:", ingredient);
    return;
  }

  const ingDescription = document.getElementById(ingDescriptionId);

  // Helper function to split an array into chunks of a given size
  function chunkArray(array, size) {
    let chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  // Split the ulItems into chunks of 3
  const chunkedItems = chunkArray(ingData.ulItems, 3);
  const newLabel = ingData.new === true ? `<span class="pink">NEW</span>` : "";
  // Create the content for the ingredient description
  let html = `
    <img src="${ingData.imgUrl}" alt="${ingData.title}" />
    <h4>${ingData.title} ${newLabel}</h4>
    ${ingData.description ? `<p>${ingData.description}</p>` : ""}
    ${chunkedItems
      .map(
        (chunk) => `
          <ul>
            ${chunk.map((item) => `<li>${item}</li>`).join("")}
          </ul>
        `
      )
      .join("")}
  `;
  if(ingDescription){
    ingDescription.innerHTML = html;
  }

  // Update active class if an element is provided
  if (element) {
    updateActiveClass(element);
  }
}

function mobIngGenerate(obj, type, ingDescriptionId) {
  console.log("WHY IM HERE 2 ", obj, type, ingDescriptionId);
  // Determine the target container based on the 'type' parameter
  const targetContainer =
    type === "BloatBurn" ? "toggle3Content" : "toggle4Content";
  const ingDescription = document.getElementById(ingDescriptionId);

  // Clear any previous content in the target container
  ingDescription.innerHTML = "";

  // Loop through all ingredients in the object and generate separate <div> elements
  for (let ingredient in obj) {
    const ingData = obj[ingredient];

    if (!ingData) {
      console.error("No data found for ingredient:", ingredient);
      continue;
    }

    // Create the full HTML structure including the outer div for each ingredient
    const newLabel =
      ingData.new === true ? `<span class="pink">NEW</span>` : "";
    let html = `
      <div class="ingDescription">
        <img src="${ingData.imgUrl}" alt="${ingData.title}" />
        <h4>${ingData.title} ${newLabel}</h4>
        <ul>
          ${ingData.ulItems.map((item) => `<li>${item}</li>`).join("")}
        </ul>
      </div>
    `;

    // Append the created HTML to the target container
    ingDescription.innerHTML += html;
  }

  // Update active class for the clicked element
  //if (element) {
  // updateActiveClass(element);
  //}
}

// Function to set the first ingredient as active and display its data on page load
function setInitialActiveContent(contentType) {
  const isMobile = window.innerWidth <= 768;
  console.log("Initializing content for:", contentType, "Mobile:", isMobile);

  if (contentType === "menopause") {
    const firstIngredient = "Bacopa";
    if (isMobile) {
      mobIngGenerate(dailyMenopauseObj, "Menopause", "toggle4Content");
    } else {
      populateIngDescription(
        dailyMenopauseObj,
        firstIngredient,
        "sec2IngDescription2"
      );
      document
        .querySelector("#toggle4Content .keyIngredients li")
        .classList.add("activeLi");
    }
  } else if (contentType === "bloatburn") {
    const firstIngredient = "GreenselectPhytosome";
    if (isMobile) {
      mobIngGenerate(BloatBurnObj, "BloatBurn", "toggle3Content");
    } else {
      console.log("IM HERE AND ELSE", );
      populateIngDescription(
        BloatBurnObj,
        firstIngredient,
        "sec2IngDescription2"
      );
      document
        .querySelector("#toggle3Content .keyIngredients li")
        .classList.add("activeLi");
    }
  } else {

  const firstLi = document.querySelector("#toggle4Content .keyIngredients li");
  if (firstLi) {
    const firstIngredient = "Reishi";
    populateIngDescription(acheFreeObj, firstIngredient, "sec2IngDescription2");
    firstLi.classList.add("activeLi");
  } else {
    console.warn("No list item found in #toggle4Content .keyIngredients");
  }

  console.log("Unknown content type:", contentType);
}

}

// Function to update active class on click
function updateActiveClass(element) {
  if (!element) {
    return;
  }
  const listItems = element.closest("ul").querySelectorAll("li");

  listItems.forEach((item) => {
    // Remove activeLi class from all items
    item.classList.remove("activeLi");
  });

  // Add activeLi class to the clicked item
  element.classList.add("activeLi");
}
function manuallyAddactiveLi(topId, liNumber) {
  // Find the parent container
  const container = document.getElementById(topId);

  // Find the <ul> element inside the container
  const ul = container.querySelector(".keyIngredients ul");

  // Get all the <li> elements inside the <ul>
  const listItems = ul.querySelectorAll("li");

  // Remove the 'activeLi' class from all <li> elements
  listItems.forEach((item) => {
    item.classList.remove("activeLi");
  });

  // Add the 'activeLi' class to the specified <li> based on liNumber
  if (listItems[liNumber]) {
    listItems[liNumber].classList.add("activeLi");
  } else {
    console.error("Invalid liNumber: No such item exists.");
  }
}

// Ensure that the first item is active and displayed on initial load
document.addEventListener("DOMContentLoaded", () => {
  // Determine the body ID
  const bodyId = document.body.id;

  // Call the function with the appropriate parameter
  if (bodyId === "daily-menopause-supplement") {
    setInitialActiveContent("menopause");
  } else if (bodyId === "ache-free") {
    setInitialActiveContent("ache-free");
  } else if (bodyId === "bloatburn™") { 
    setInitialActiveContent("bloatburn");
  } else if (bodyId === "intimate") { 
    setInitialActiveContent("intimate");
  }
});
//Toggale Faq Section END
//Seals Subscription TOTAL CALCULATE START

//Seals Subscription TOTAL CALCULATE END
//Bundle Force Click Second Product ANd total Calculation START

//Bundle Force Click Second Product ANd total Calculation END

// WeightLoss Calculator
window.onload = function () {
  const weightStoneInput = document.getElementById("weightStone");
  const weightPoundsInput = document.getElementById("weightPounds");
  const activityDropdown = document.getElementById("activityDropdown");
  const calriedDayGrams = document.querySelector("#calriedDay .grams");
  const proteinDayGrams = document.querySelector("#proteinDay .grams");
  const carbohydratesDayGrams = document.querySelector(
    "#CarbohydratesDay .grams"
  );
  const fatsDayGrams = document.querySelector("#fatsDay .grams");

  // Helper function to add commas
  function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  const calculateWeightBtn = document.getElementById("calculateWeightBtn");

  if (!calculateWeightBtn) {
    console.log("Button with ID 'calculateWeightBtn' not found.");
    return;
  }
  document
    .getElementById("calculateWeightBtn")
    .addEventListener("click", function () {
      const stoneValue = parseFloat(weightStoneInput.value);
      const activityMultiplier = parseFloat(activityDropdown.value);

      if (!isNaN(stoneValue)) {
        // Convert stone to pounds
        const pounds = stoneValue * 14;
        weightPoundsInput.value = pounds.toFixed(2);

        // Calculate total calories
        if (!isNaN(activityMultiplier)) {
          const calories = pounds * activityMultiplier;
          calriedDayGrams.textContent = formatNumber(Math.round(calories));

          // Calculate protein, carbohydrates, and fats
          const protein = Math.round((calories * 0.3) / 4);
          const carbohydrates = Math.round((calories * 0.45) / 4);
          const fats = Math.round((calories * 0.25) / 9);

          proteinDayGrams.textContent = formatNumber(protein) + "g";
          carbohydratesDayGrams.textContent = formatNumber(carbohydrates) + "g";
          fatsDayGrams.textContent = formatNumber(fats) + "g";
        } else {
          calriedDayGrams.textContent = "";
          proteinDayGrams.textContent = "";
          carbohydratesDayGrams.textContent = "";
          fatsDayGrams.textContent = "";
        }
      } else {
        weightPoundsInput.value = "";
        calriedDayGrams.textContent = "";
        proteinDayGrams.textContent = "";
        carbohydratesDayGrams.textContent = "";
        fatsDayGrams.textContent = "";
      }
    });
};
document.addEventListener("DOMContentLoaded", function () {
    const menuItem1 = document.querySelector("#NavStandard > .menu__item:nth-child(2)");
    const menuItem2 = document.querySelector("#NavStandard > .menu__item:nth-child(3)");
    const menuItem3 = document.querySelector("#NavStandard > .menu__item:nth-child(4)");
    const hoverDiv1 = document.getElementById("hoverDiv1");
    const hoverDiv2 = document.getElementById("hoverDiv2");
    const hoverDiv3 = document.getElementById("hoverDiv3");

    function setupHover(menuItem, hoverDiv) {
        let isHoveringMenu = false;
        let isHoveringDiv = false;
        let hideTimeout;

        function showHoverDiv() {
            clearTimeout(hideTimeout); // Cancel any pending hide
            hoverDiv.style.display = "flex";
            hoverDiv.style.opacity = "1"
        }

        function hideHoverDiv() {
                if (!isHoveringMenu && !isHoveringDiv) {
                    hoverDiv.style.opacity = "0";
                    hoverDiv.style.display = "none"
                }
        }

        menuItem.addEventListener("mouseenter", () => {
            isHoveringMenu = true;
            showHoverDiv();
        });

        menuItem.addEventListener("mouseleave", () => {
                if (!isHoveringDiv) {
                    isHoveringMenu = false;
                    hideHoverDiv();
                }
        });

        hoverDiv.addEventListener("mouseenter", () => {
            isHoveringDiv = true;
            showHoverDiv();
        });

        hoverDiv.addEventListener("mouseleave", () => {
            isHoveringDiv = false;
            hideHoverDiv();
        });
    }

    if (menuItem1 && hoverDiv1) setupHover(menuItem1, hoverDiv1);
    if (menuItem2 && hoverDiv2) setupHover(menuItem2, hoverDiv2);
    if (menuItem3 && hoverDiv3) setupHover(menuItem3, hoverDiv3);
});

const originalFetch = window.fetch;
window.fetch = function (...args) {
  const [url] = args;

  if (
    url.includes('/cart/add') ||
    url.includes('/cart/change') ||
    url.includes('/cart/update')
  ) {
    return originalFetch.apply(this, args).then(response => {
      setTimeout(() => {
        updateCartCount();
      }, 300);

      return response;
    });
  }

  return originalFetch.apply(this, args);
};

// Initial load
document.addEventListener('DOMContentLoaded', updateCartCount);

function updateAllCartCountElements(count) {
  document.querySelectorAll('.custtomCartCount').forEach(el => {
    el.textContent = count;
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log("Cart item count:", cart.item_count);
      updateAllCartCountElements(cart.item_count);
    });
}